import { render } from "./Avaria.vue?vue&type=template&id=ac3f412e"
import script from "./Avaria.vue?vue&type=script&lang=js"
export * from "./Avaria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__